import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { InconsistentReferenceTitle } from "../../../../../../../../../components/Common/InconsistentReferenceTooltip/InconsistentReference";
import { TransactionSourceApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	inconsistentReferenceId: boolean;
	source?: TransactionSourceApi;
}

const TransactionDetailsCard = ({ inconsistentReferenceId, source }: Props) => {
	const { t } = useTranslation();

	if (!source) return null;

	const sourceEntries = Object.entries(source);

	const getSourceDetailValue = (sourceType: string, sourceValue: string) => {
		return sourceType === "type" ? t(`enums.online_payments.${sourceValue}`) : sourceValue;
	};

	return (
		<Card>
			<Card.Body>
				<InconsistentReferenceTitle
					inconsistentReferenceId={inconsistentReferenceId}
					titleText={t("common.word.source", { ns: "lib" })}
				/>
				<div className="d-flex flex-column row-gap-2">
					{sourceEntries.map(([sourceName, sourceValue]) => {
						if (!sourceValue) {
							return null;
						}

						return (
							<div key={sourceName} className="d-flex justify-content-between column-gap-2">
								<span className="mw-50">{`${t(`enums.transaction_detail.${sourceName}`)}:`}</span>
								<span className="font-weight-bold mw-50 text-end">
									{getSourceDetailValue(sourceName, sourceValue)}
								</span>
							</div>
						);
					})}
				</div>
			</Card.Body>
		</Card>
	);
};

export default TransactionDetailsCard;

// t("enums.transaction_detail.external_id")
// t("enums.transaction_detail.type")
// t("enums.transaction_detail.provider")
// t("enums.transaction_detail.number")
